import { render } from "./Page.vue?vue&type=template&id=365fb706&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=365fb706&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-365fb706"

export default script